
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="名称">
              <a-input placeholder="请输入名称" v-model="queryParam.name"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => queryParam = {}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button
        @click="$refs.sxSupplierAddOrUpdate.init('','add')"
        icon="plus"
        type="primary"
        v-action="'purchase:supplier-form:add'"
      >新建</a-button>
    </div>
    <s-table
      bordered
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
    </s-table>
    <sxSupplier-add-or-update
      @ok="queryPage"
      ref="sxSupplierAddOrUpdate"
    />
  </a-card>
</template>

<script>
import { TableMixin } from '@/mixins/TableMixin'
import { fetchList, delObj } from '@/api/common/SxSupplier'
import sxSupplierAddOrUpdate from './SxSupplierAddOrUpdate'
import { enterEvent } from '@/utils/util'
export default {
  name: 'SxSupplierView',
  mixins: [TableMixin],
  components: {
    sxSupplierAddOrUpdate
  },
  data () {
    return {
      queryParam: {
        test: ''
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '100px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        // {
        //   title: '主键',
        //   dataIndex: 'id'
        // },
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '手机号码',
          dataIndex: 'phone'
        },
        {
          title: '地址',
          dataIndex: 'address'
        },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime'
        // },
        // {
        //   title: '更新时间',
        //   dataIndex: 'updateTime'
        // },
        // {
        //   title: '创建者ID',
        //   dataIndex: 'createBy'
        // },
        // {
        //   title: '删除标记',
        //   dataIndex: 'delFlag'
        // },
        {
          title: '操作',
          width: '200px',
          customRender: (record) => {
            return (
              <div>
                <span v-action="purchase:supplier-form:show">
                  <a onClick={(e) => this.show(record)}>查看</a>
                </span>
                <span v-action="purchase:supplier-form:edit">
                  <a-divider type="vertical" />
                  <a onClick={(e) => this.edit(record)}>修改</a>
                </span>
                <span v-action="purchase:supplier-form:del">
                  <a-divider type="vertical" />
                  <a-popconfirm title="是否删除" onConfirm={() => this.deleteItem(record)} okText="是" cancelText="否">
                    <a-icon slot="icon" type="question-circle-o" style="color: red" />
                    <a href="javascript:;" style="color: red">删除</a>
                  </a-popconfirm>
                </span>
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    show (record) {
      this.$refs.sxSupplierAddOrUpdate.init(record.id, 'show')
    },
    edit (record) {
      this.$refs.sxSupplierAddOrUpdate.init(record.id, 'edit')
    },
    deleteItem (record) {
      delObj(record.id).then(res => {
        this.$message.info('删除成功')
        this.queryPage()
      })
    }
  },
  created () {
    enterEvent(this.queryPage)
  }
}
</script>

<style scoped>

</style>
